'use strict';

var { grecaptchaGenerateToken } = require('../common/grecaptchaUtils');
/**
 * Validates if the given string is a properly formatted email address.
 *
 * @param {string} email - The email address to validate.
 * @returns {boolean} Returns `true` if the email is valid, otherwise `false`.
 */
function isValidEmail(email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

/**
 * Initializes the chat widget toggle, ripple effect, outside click handling,
 * and embedded live chat open/minimize functionality.
 */
function initChatWidget() {
    var $widget = $('.chat-widget');
    if (!$widget.length) return;

    var $toggleBtn = $widget.find('#chatToggle');
    var $options = $widget.find('#chatOptions');
    var $liveChatBtn = $widget.find('#liveChatBtn');
    $toggleBtn.on('click', function (e) {
        e.stopPropagation();

        $options.toggleClass('open');
        $toggleBtn.toggleClass('active');

        var $ripple = $('<span class="ripple"></span>');
        var rect = this.getBoundingClientRect();

        $ripple.css({
            left: (e.clientX - rect.left) + 'px',
            top: (e.clientY - rect.top) + 'px'
        });

        $toggleBtn.append($ripple);

        setTimeout(function () {
            $ripple.remove();
        }, 600);
    });

    $('body').on('click.chatWidget', function () {
        $options.removeClass('open');
        $toggleBtn.removeClass('active');
    });

    $widget.on('click', function (e) {
        e.stopPropagation();
    });
    $liveChatBtn.on('click', function () {
        var embeddedMessagingContainer = $('.embeddedMessagingFrame');
        if (embeddedMessagingContainer.length > 0 && embeddedMessagingContainer.hasClass('isMinimized')) {
            window.embeddedservice_bootstrap.utilAPI.launchChat();
        } else {
            $('#embeddedMessagingConversationButton').click();
        }
    });
}

initChatWidget();

module.exports = function () {
    $('.subscribe-email').on('click', async function (e) {
        var url = $(this).data('href');
        var emailField = $('input[name=hpEmailSignUp]');
        var emailId = emailField.val();
        var patternMismatchMessage = emailField.attr('data-pattern-mismatch');

        var $form = $(this).closest('form');
        var $errorFeedback = $form.find('.invalid-feedback');

        $errorFeedback.addClass('d-none').text(''); // Resetting error msg, input border
        emailField.removeClass('is-invalid');

        if (!emailId) { // Scenario 1: Empty input field
            $errorFeedback.removeClass('d-none');
        } else if (!isValidEmail(emailId)) { // Scenario 2: Invalid email format
            $errorFeedback.removeClass('d-none').text(patternMismatchMessage);
            emailField.addClass('is-invalid');
            e.preventDefault();
        } else { // Scenario 2: Controller Hit with valid email id
            e.preventDefault();
            var recaptchaToken = await grecaptchaGenerateToken();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    emailId: emailId,
                    recaptchaToken: recaptchaToken
                },
                success: function (data) {
                    if (data.success) {
                        $('body').trigger('successToast', data.msg);
                        emailField.val('').removeClass('has-value');
                    } else {
                        $('body').trigger('failureToast', data.msg);
                        emailField.val('').removeClass('has-value');
                    }
                },
                error: function () {
                    // TODO
                }
            });
        }
    });

    $('#hpEmailSignUp').on('input', function () {
        $(this).val($(this).val().replace(/[^\w@.\-+]/g, ''));
        $(this).siblings('.invalid-feedback').addClass('d-none').text('');
        $(this).removeClass('is-invalid');
        if (!isValidEmail($(this).val())) {
            $(this).siblings('.invalid-feedback').removeClass('d-none').text($(this).attr('data-pattern-mismatch'));
            $(this).addClass('is-invalid');
        }
    });
};
